import { VERSION } from "./version";

export const required = (key: keyof ImportMetaEnv): string => {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`Environment variable ${key} missing`);
  }
  return value;
};

const TALENT_SCORE_URL = required("VITE_TALENT_SCORE_URL");
const TALENT_BOOST_URL = required("VITE_TALENT_BOOST_URL");

export const CONFIG = {
  TALENT_BOOST_URL,
  TALENT_SCORE_URL,
  VERSION,
};

declare global {
  interface Window {
    CONFIG: typeof CONFIG;
  }
}
window.CONFIG = CONFIG;
